export default __webpack_public_path__ + "static/media/banner-0.83a86819.jpg";